import { Icon } from '@column/column-ui-kit';

import { AchIcon } from './Ach';
import { BookIcon } from './Book';
import { CheckContinue } from './CheckContinue';
import { CheckJam } from './CheckJam';
import { CheckScannerIcon } from './CheckScanner';
import { ClockIcon } from './Clock';
import { InterestPayoutIcon } from './InterestPayout';
import { IntlWireIcon } from './IntlWire';
import { IssueCheckIcon } from './IssueCheck';
import { LoanDisbursementIcon } from './LoanDisbursement';
import { LoanPaymentIcon } from './LoanPayment';
import { RDCIcon } from './RDC';
import { RealtimeIcon } from './Realtime';
import { WireIcon } from './Wire';

export const IconTransfers = {
  Ach: AchIcon,
  Bank: Icon.Bank,
  Debit: Icon.Transfer.Debit,
  Book: BookIcon,
  CheckScanner: CheckScannerIcon,
  Clock: ClockIcon,
  IntlWire: IntlWireIcon,
  IssueCheck: IssueCheckIcon,
  RDC: RDCIcon,
  Realtime: RealtimeIcon,
  Wire: WireIcon,
  CheckJam,
  CheckContinue,
  InterestPayout: InterestPayoutIcon,
  LoanDisbursement: LoanDisbursementIcon,
  LoanPayment: LoanPaymentIcon,
} as const;

export type IconTransferType = keyof typeof IconTransfers;
